var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgStarSpecial = function SvgStarSpecial(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 80 81"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M38.117 3.129A2.13 2.13 0 0 1 40 2.015v32.968a.36.36 0 0 0-.321.19l-2.956 5.35a.37.37 0 0 1-.142.143l-11.84-13.86c.348-.193.642-.482.84-.844L38.119 3.129Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "m43.419 40.666 11.84-13.86a2.15 2.15 0 0 1-.841-.844L41.882 3.129A2.13 2.13 0 0 0 40 2.015v32.968c.126 0 .252.063.322.19l2.955 5.35q.051.093.142.143",
    opacity: 0.6
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "m43.419 40.667 11.84-13.86c.313.173.67.269 1.04.269h21.55c.936 0 1.645.555 1.964 1.28L49.123 40.93a.36.36 0 0 0-.336-.217h-5.189a.37.37 0 0 1-.18-.046Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "m49.122 40.93 30.69-12.573a2.12 2.12 0 0 1-.427 2.364L62.831 47.7c-.25.256-.428.566-.524.899l-17.305-3.071a.4.4 0 0 1 .091-.157l3.956-4.033a.36.36 0 0 0 .073-.408",
    clipRule: "evenodd",
    opacity: 0.6
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M46.31 52.2a.36.36 0 0 0 .145-.386L45 45.714a.37.37 0 0 1 .004-.186l17.305 3.07a2.15 2.15 0 0 0-.028 1.097l6.15 25.92a2.12 2.12 0 0 1-.853 2.251z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M40 49.167q.091 0 .175.042l5.752 3.016c.134.07.277.049.383-.026l21.266 25.668a2.12 2.12 0 0 1-2.236.142L41.026 65.19A2.15 2.15 0 0 0 40 64.943z",
    opacity: 0.6
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M33.584 52.414a.36.36 0 0 0 .388.021l5.855-3.222a.4.4 0 0 1 .172-.046v15.775c-.35.004-.7.094-1.015.268L14.24 78.91a2.11 2.11 0 0 1-2.26-.111z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M34.996 45.527q.026.092.003.188l-1.56 6.31c-.04.162.03.308.145.389L11.98 78.797a2.12 2.12 0 0 1-.866-2.28l6.594-26.814c.09-.37.08-.75-.021-1.104z",
    opacity: 0.6
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M34.996 45.528 17.688 48.6a2.15 2.15 0 0 0-.526-.908L.614 30.722a2.12 2.12 0 0 1-.427-2.366l30.69 12.574a.36.36 0 0 0 .073.408l3.954 4.031q.066.069.091.159Z"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M23.701 27.076H2.152c-.936 0-1.645.555-1.965 1.28l30.69 12.574a.36.36 0 0 1 .336-.217H36.4a.37.37 0 0 0 .181-.047l-11.84-13.86c-.314.174-.67.27-1.041.27Z",
    opacity: 0.6
  })));
};
export default SvgStarSpecial;